import { T } from '@fire/i18n/i18n-constants';

export const MAIN_LIST_MINIMUM = 3;

export const PREFIX = T?.FlexibleDates;
